import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../Utils/axiosConfig";
import { apiMessage } from "../Utils/apiMessage";
import { LAST_DAIRY_KEY } from "../Utils/session";
import AdBanner from "./Shared/AdBanner";

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ userName: "", password: "" });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("isAuthenticated")) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setApiError("");
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.userName.trim()) newErrors.userName = "वापरकर्ता नाव आवश्यक आहे";
    if (!formData.password.trim()) newErrors.password = "पासवर्ड आवश्यक आहे";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await http.post("login/authenticate", {
        username: formData.userName,
        password: formData.password,
      });
      if (res.code === "LOGIN_SUCCESSFULLY") {
        const user = res.data;
        localStorage.setItem("user_name", user.mr_name);
        localStorage.setItem("dairy_name", user.dairy_name);
        localStorage.setItem("dairy_id", user.dairy_id);
        localStorage.setItem("user_id", user.id);
        // Survives logout on purpose — it is what lets the login page show this
        // dairy's advert next time. See Utils/session.js.
        if (user.mst_id) localStorage.setItem(LAST_DAIRY_KEY, user.mst_id);
        localStorage.setItem("isAuthenticated", "true");
        navigate("/dashboard", { replace: true });
      } else {
        setApiError(apiMessage(res, "लॉगिन अयशस्वी"));
      }
    } catch (err) {
      console.error("Login error:", err);
      setApiError(apiMessage());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lgform">
      <img src="/logo.png" alt="Logo" className="logo" />
      <form onSubmit={handleSubmit}>
        <div className="login-form">
          <h2>सभासद लॉगिन</h2>
          <label className="label">User Name</label>
          <input
            type="text"
            name="userName"
            placeholder="Enter valid User Name"
            value={formData.userName}
            onChange={handleChange}
          />
          {errors.userName && <p className="error">{errors.userName}</p>}

          <label className="label">Password</label>
          <input
            type="password"
            name="password"
            placeholder="Enter valid Password"
            value={formData.password}
            onChange={handleChange}
          />
          {errors.password && <p className="error">{errors.password}</p>}
          {apiError && <p className="error">{apiError}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "लॉगिन करत आहे..." : "लॉगिन करा"}
          </button>
        </div>
      </form>
      <AdBanner />
    </div>
  );
};

export default LoginForm;
